import "./style.css";

export const ControlGroupSkeleton = ({ style }) => (
    <div className='control-group skeleton-loader' style={style}/>
);